module.exports = __webpack_public_path__ + "media/images/emblems/Coeuve-69c7baebbb08951e0ad036b24544774f.png";